var styles = {
  "ImageContainer": "Polaris-EmptyState__ImageContainer",
  "Image": "Polaris-EmptyState__Image",
  "loaded": "Polaris-EmptyState--loaded",
  "imageContained": "Polaris-EmptyState--imageContained",
  "SkeletonImageContainer": "Polaris-EmptyState__SkeletonImageContainer",
  "SkeletonImage": "Polaris-EmptyState__SkeletonImage"
};

export { styles as default };
